export default __webpack_public_path__ + "static/media/edit-gray.bec3e68e.svg";